<script setup lang="ts">
import { computed } from 'vue'
import { useRouter } from 'vue-router'
import { useStore } from 'vuex'

import CheckmarkIcon from '@/assets/icons/onboarding-checkmark.svg?component'
import PlayIcon from '@/assets/icons/onboarding-play.svg?component'
import CloseIcon from '@/assets/icons/remove.svg?component'
import { STEPS_SETTINGS } from '@/components/onboarding/StepCardData'
import BoxComponent from '@/ui-library/atoms/BoxComponent/BoxComponent.vue'
import FlexComponent from '@/ui-library/atoms/FlexComponent/FlexComponent.vue'
import TypographyComponent from '@/ui-library/atoms/TypographyComponent/TypographyComponent.vue'

const store = useStore()
const route = useRouter()
const currentStep = computed(() => store.getters['onboarding/currentOnboardingStep'])

const stepsData = [
  {
    text: 'Step 1 — Setup Order Collection',
    route: 'orders',
    menuItemCard: STEPS_SETTINGS.find((card) => card.step === 1)?.id,
    firstCard: STEPS_SETTINGS.filter((card) => card.step === 1)[1].id,
  },
  {
    text: 'Step 2 — Start a welcome campaign',
    route: 'campaign-creation',
    menuItemCard: STEPS_SETTINGS.find((card) => card.step === 2)?.id,
    firstCard: STEPS_SETTINGS.filter((card) => card.step === 2)[1].id,
  },
  {
    text: 'Step 3 - Manage a campaign',
    route: 'campaign-creation',
    menuItemCard: STEPS_SETTINGS.find((card) => card.step === 3)?.id,
    firstCard: STEPS_SETTINGS.filter((card) => card.step === 3)[1].id,
  },
]
</script>

<template>
  <div class="container">
    <button class="close" @click="store.dispatch('onboarding/showOnboardingClosePopup')">
      <CloseIcon />
    </button>
    <BoxComponent :mb="24">
      <TypographyComponent variant="headline-large" color="#000000"> Welcome tour </TypographyComponent>
    </BoxComponent>
    <FlexComponent :gap="16">
      <button
        v-for="(step, index) in stepsData"
        :key="step.text"
        :class="[
          'step-button',
          {
            'is-active': index + 1 === currentStep,
            'is-finished': index + 1 < currentStep,
          },
        ]"
        @click="
          () => {
            if (route.currentRoute.value.name === step.route) {
              store.dispatch('onboarding/setCurrentCard', step.firstCard)
            } else {
              store.dispatch('onboarding/setCurrentCard', step.menuItemCard)
            }
            store.dispatch('onboarding/setCurrentStep', index + 1)
            store.dispatch('onboarding/setOnboardingActivity', true)
          }
        "
      >
        <FlexComponent :gap="8" align="center">
          <el-icon :size="24">
            <CheckmarkIcon v-if="index + 1 < currentStep" />
            <PlayIcon v-if="index + 1 >= currentStep" />
          </el-icon>
          <TypographyComponent variant="label-large" color="#000000">
            {{ step.text }}
          </TypographyComponent>
        </FlexComponent>
      </button>
    </FlexComponent>
  </div>
</template>

<style scoped lang="scss">
.container {
  position: relative;
  margin-top: 24px;
  padding: 48px;
  border-radius: 16px;
  background: var(--invertedLight);
}

.close {
  position: absolute;
  top: 12px;
  right: 12px;

  background: transparent;
  border: none;
  padding: 4px;
}

.step-button {
  padding: 8px 16px;
  border-radius: 64px;
  background: transparent;
  border: 1px solid rgba(0, 0, 0, 0.7);

  &.is-active {
    background: #fff;
    border: 3px solid var(--pale-lavender-300);
  }

  &.is-finished {
    border-color: var(--fresh-mint-400);
  }
}
</style>
